import styled from 'styled-components';
import {
  flexbox,
  flexDirection,
  justifyContent,
  alignItems
} from '../../styles/helpers/flexbox';

export const LineChartWrapper = styled.div`
  ${flexbox()};
  ${flexDirection('column')};

  height: 100%;
  box-sizing: border-box;
  padding: 2px 0;
`;

export const Section1 = styled.div`
  ${flexbox()};
  ${alignItems('center')};
  ${justifyContent('flex-start')};

  width: 100%;
  height: 20%;
  padding-left: 10px;
  font-size: 10px;
  color: #008902;
  border-bottom: 1px dashed #008902;
`;

export const Section2 = styled(Section1)`
  border-bottom: 1px dashed #2452bb;
  color: #2452bb;
  height: 35%;
`;

export const Section3 = styled(Section1)`
  border-bottom: none;
  color: #900012;
  height: 50%;
`;

export const Footer = styled(Section1)`
  height: 20px;
  font-size: 11px;
  font-weight: 600;
  color: #000;
  border-bottom: none;
`;

export const ChartLinesWrapper = styled.div`
  ${flexbox()};
  ${flexDirection('column')};
  ${alignItems('center')};
  ${justifyContent('space-between')};

  height: 100%;
  width: 38px;
  height: 158px;
  font-size: 11px;
`;

export const ChartLine = styled.div`
  width: 1px;
  height: 130px;
  background-color: rgb(207, 207, 207, 0.3);
`;

export const Wrapper = styled.div`
  ${flexbox()};
  ${justifyContent('flex-end')};

  height: 135px;
  width: inherit;
  position: absolute;
  box-sizing: border-box;
  padding-right: 40px;
`;

export const ChartPoint = styled.div((props) => {
  return `
  ${flexbox()};

  width: 10px;
  height: 10px;
  background-color: ${props.color};
  border-radius: 5px;
  margin-left: -4px;
  position: absolute;
  bottom: ${props.position - 5}px;
`;
});

export const Position = styled.div((props) => {
  const { colours } = props.theme;

  return `
        color: ${props.enabled ? colours.grey[700] : colours.grey[100]};
    `;
});



// WEBPACK FOOTER //
// ./components/line-chart/line-chart.styled.js